
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rapid-pro-power-bank",
      function () {
        return require("private-next-pages/rapid-pro-power-bank/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rapid-pro-power-bank"])
      });
    }
  